export default __webpack_public_path__ + "static/media/press-15.2ea5c319.jpg";